export class ExternalCrewDataUpdate {
    anacCode: string;
    email: string;
    password: string
}